<template>
  <div class="culture">
    <drug-guide title="企业文化" :headimg="culHead" :enimg="enImg"></drug-guide>
    <div class="cul-tab">
      <div class="cul-tablist">
        <div :class="tabidx == index ? 'cul-tabitem on' : 'cul-tabitem'" v-for="(item, index) in tabList" :key="index" @click="getTab(index)">{{ item.name }}</div>
      </div>
    </div>
    <div class="cullist">
      <div class="culitem" v-for="(item, index) in culList" :key="index" @click="getDetail(item.id)">
        <div class="culitem-detail">
          <div class="culitem-date">
            <div class="culitem-day">{{ item.day }}</div>
            <div class="culitem-time">{{ item.datetime }}</div>
          </div>
          <div class="culitem-con">
            <div class="culitem-title">{{ item.title }}</div>
            <div class="culitem-desc">
              <span class="culitem-type">{{ item.cate_name }}</span>
              <span>{{ item.bref }}</span>
            </div>
          </div>
        </div>
        <div class="culitem-btn">
          <div>查看全文</div>
          <img :src="culRight" alt="">
        </div> 
      </div>
      <el-pagination class="workpage" background layout="prev, pager, next" :total="total" prev-text="上一页" next-text="下一页" @current-change="currentChange"></el-pagination>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
import { getCate, getList } from "@/api/index";
export default {
  name: "Culture",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      culHead: "static/images/culture/cul-head.png",
      enImg: "static/images/culture/cul-en.png",
      culRight: "static/images/culture/cul-right.png",
      enBg: "static/images/culture/cul-bg.png",
      tabidx: 0,
      tabList: [
        {
          name: "全部",
          id: 0
        }
      ],
      culList: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    pid: {
      get () {
        return this.$store.state.pid;
      }
    },
  },
  watch: {
    '$store.state.keyword'(val) {
      var activeVal = this.$store.state.activeVal;
      if(activeVal == 5) {
        getList(this.pid, this.tabList[this.tabidx].id, this.page, val).then((res) => {
          if(res.data.code == 1) {
            this.culList = res.data.data.rows;
            this.total = res.data.data.total;
          }
        })
      }
    }
  },
  created() {
    this.getCulList(null);
  },
  methods: {
    // 分页
    currentChange(index) {
      this.page = index;
      this.getCulList(this.tabList[this.tabidx].id);
    },
    // 类型切换
    getTab(index) {
      this.tabidx = index;
      this.page = 1;
      this.getCulList(this.tabList[index].id);
    },
    // 详情跳转
    getDetail(id) {
      this.$router.push({
        path: "/culture/detail",
        query: { id }
      })
    },
    getCateList() {
      var id = this.pid ? this.pid : 4;
      getCate(id).then((res) => {
        this.tabList = [
          {
            name: "全部",
            id: null,
            pid: this.pid
          }
        ];
        if(res.data.code == 1) {
          var list = res.data.data;
          for(let i in list) {
            this.tabList.push(list[i]);
          }
        }
      })
    },

    // 获取列表数据
    getCulList(cateId) {
      getList((this.pid ? this.pid : 4), cateId, this.page, "").then((res) => {
        if(res.data.code == 1) {
          this.culList = res.data.data.rows;
          this.total = res.data.data.total;
          for(let i in this.culList) {
            var datetime = this.culList[i].ctime.split("-");
            this.culList[i].day = datetime[2];
            this.culList[i].datetime = datetime[0] + '-' + datetime[1];
          }
        }
      })
    }
  },
  mounted() {
    this.$store.commit("getactive", 5);
    this.getCateList();
  }
}
</script>

<style lang="scss" scoped>
.culture {
  .cul-tab {
    width: 100%;
    height: 50px;
    background: #fff;
    .cul-tablist {
      width: 80%;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      cursor: pointer;
      .cul-tabitem {
        height: 100%;
        line-height: 50px;
        padding: 0 32px;
        color: #7C828A;
        &.on {
          color: #fff;
          background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
          font-family: "PingFang SC-Medium", "PingFang SC";
        }
      }
    }
  }
  .cullist {
    width: 80%;
    height: auto;
    overflow: hidden;
    margin: 20px auto 0 auto;
    background-color: #fff;
    .culitem {
      width: 100%;
      height: 130px;
      border-bottom: 1px solid #ddd;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 0 20px;
      box-sizing: border-box;
      .culitem-detail {
        width: 80%;
        display: flex;
        align-items: center;
        .culitem-date {
          width: 130px;
          height: 130px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .culitem-day {
            font-size: 40px;
            font-family: "Microsoft YaHei-Bold", "Microsoft YaHei";
            font-weight: bold;
            color: #1492FF;
          }
        }
        .culitem-con {
          width: 80%;
          height: 85px;
          padding: 0 20px;
          border-left: 1px solid #ddd;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          overflow: hidden;
          .culitem-title {
            width: 100%;
            height: 40px;
            font-size: 22px;
            font-weight: 400;
            color: #181E23;
            line-height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .culitem-desc {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            font-weight: 400;
            color: #7C828A;
            .culitem-type {
              color: #4392EC;
              margin-right: 10px;
            }
          }
        }
      }
      .culitem-btn {
        width: 95px;
        height: 30px;
        border: 1px solid #0B7BDB;
        color: #0B7BDB;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 10px;
          height: 10px;
          margin-left: 5px;
        }
      }
    }
    .culitem:hover {
      background-image: url('../../../static/images/culture/cul-bg.png');
      background-size: cover;
    }
    .culitem:hover .culitem-date, .culitem:hover .culitem-detail .culitem-date .culitem-day, .culitem:hover .culitem-detail .culitem-con .culitem-title, .culitem:hover .culitem-detail .culitem-con .culitem-desc, .culitem:hover .culitem-detail .culitem-con .culitem-desc .culitem-type {
      color: #fff;
    }
    .culitem:hover .culitem-btn {
      background: #fff;
    }
    .workpage {
      width: 90%;
      margin: 40px auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// 分页器样式
.culture /deep/ .el-pagination.is-background {
  color: #909090;
  font-weight: 400;
}
.culture /deep/ .el-pagination.is-background .el-pager li {
  width: 38px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  margin: 0 5px;
  font-size: 16px;
}
// 上一页/下一页
.culture /deep/ .el-pagination.is-background button {
  height: 40px;
  padding: 0 10px;
}
.culture /deep/ .el-pagination.is-background button span {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/culture/culture.vue